export default __webpack_public_path__ + "static/media/icon-pdf.ca1012fb.svg";